module.exports = __webpack_public_path__ + "static/2021_vikingTeacher-9e3dfd6c3b7bc4caa7291129d682135b.png";